import { render } from "./ShoppingCartView.vue?vue&type=template&id=b15fb5b2"
import script from "./ShoppingCartView.vue?vue&type=script&lang=js"
export * from "./ShoppingCartView.vue?vue&type=script&lang=js"

import exportComponent from "/home/joeyd/Documents/Work/Clients/Rica/Development/rica-tuning-app/rica-tune-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__